exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-6ff6795c]{align-items:center;background:#e3e3e3;color:#7e8a99;display:flex;flex-direction:row;font-size:12px;font-weight:600;justify-content:center\n}", ""]);

// exports
